import { Auth } from 'aws-amplify';

const environment = {
    production: true,
    debug: false,
    offline: false,
    cloudformationLaunchStackUrl: 'https://console.aws.amazon.com/cloudformation/home?region=us-east-1#/stacks/create/review?stackName=VizCon&templateURL=https://vizcon-resources-prod.s3.amazonaws.com/iac/latest/crossAccountAccessRole.yml',
    cloudformationTemplateUrl: 'https://resources.vizcon.cloud/iac/latest/crossAccountAccessRole.yml',
    cognitoSelfSignUpEnabled: false, // To be updated based Cognito configuration after Terraform deployment
    Amplify: {
        Auth: {
            region: 'ap-northeast-2', // To be updated after Terraform deployment
            userPoolId: 'ap-northeast-2_Rv25h75PT',  // To be updated after Terraform deployment
            userPoolWebClientId: '77aci45hq957obkelo4hcpr8nd',   // To be updated after Terraform deployment
        },
        API: {
            endpoints: [
                {
                    name: 'VizConAPI',
                    endpoint: 'https://api.customer.vizcon.cloud',  // To be updated with actual domain
                    custom_header: async () => {
                        return { Authorization: (await Auth.currentSession()).getIdToken().getJwtToken() };
                    }
                }
            ]
        }
    },
    features: {
        subscriptions: false,  // Disabled for enterprise deployment
        userInvitation: false
    },
    stripe: {
        enabled: false,  // Disabled for enterprise deployment
        "redirectUrl": ""  // To be updated with actual domain
    },
    aws: {
        enabled: false,  // Disabled for enterprise deployment
        marketplaceUrl: "",  // Disabled for enterprise deployment
        subscriptionManagementUrl: "",  // Disabled for enterprise deployment
        productCode: "",  // Disabled for enterprise deployment (Lifetime product code)
        productCodeSubscription: ""  // Disabled for enterprise deployment (Subscription product code)
    },
    defaultRoleName: "vizcon",
    matomo: {
        enabled: false,  // Disabled for enterprise deployment
        containerUrl: ""
    },
    branding: {
        logoPath: "assets/img/logo/vizcon-logo.png",
        logoAlt: "VizCon Logo",
        companyName: "VizCon"
    },
    license: {
        expiryDate: null,  // Optional: ISO date string (e.g., "2024-12-31T23:59:59Z") for POC/trial licenses
        warningDays: 7     // Show warning X days before expiry
    }
};

export default environment;